import { getSessionId, setSessionId } from "./session-storage";

interface SessionResponse {
  sessionId: string;
}

interface MessageResponse {
  httpResponseCode: number;
  response?: string;
  sessionId?: string;
  inputMessageId?: string;
  responseMessageId?: string;
}

export interface ConversationMessageDto {
  type: "input" | "output";
  message: string;
  messageId: string;
  timestamp: string;
}

interface ConversationResponse {
  sessionId: string;
  messages: ConversationMessageDto[];
}

// Calls Magnum endpoints (which proxy to ESPC API)
export async function checkSession(): Promise<string> {
  const existingId = getSessionId();
  if (existingId) return existingId;

  const response = await fetch("/property-pal/session", {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) throw new Error();

  const data = (await response.json()) as SessionResponse;
  setSessionId(data.sessionId);
  return data.sessionId;
}

export async function sendMessage(message: string): Promise<MessageResponse> {
  const sessionId = await checkSession();

  const response = await fetch("/property-pal/message", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ sessionId, message }),
  });

  const data = (await response.json()) as MessageResponse;

  return data;
}

export async function getConversation(sessionId: string): Promise<ConversationResponse> {
  const response = await fetch(`/property-pal/conversation/${sessionId}`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) throw new Error();

  const data = (await response.json()) as ConversationResponse;
  return data;
}

export async function submitFeedback(
  sessionId: string,
  type: "positive" | "negative",
  feedbackText?: string,
): Promise<void> {
  const response = await fetch("/property-pal/feedback", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ sessionId, type, feedbackText }),
  });

  if (!response.ok) throw new Error();
}
